(function () {
  'use strict';

  /* Zahl in Tagen, optional mit Vorzeichen und Dezimalpunkt; Leerraum am Rand wird vorher abgeschnitten */
  var NUR_ZAHL = /^-?[0-9]+([.][0-9]+)?$/;

  function umhuellen() {
    var C = window.Cookies;
    if (!C || typeof C.set !== 'function' || C.set.lbPopupCookieConsent) return !!(C && C.set && C.set.lbPopupCookieConsent);

    var original = C.set;

    function erlaubt() {
      try { return !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.preferences); } catch (e) { return false; }
    }

    function widerruf() {
      try {
        var cb = window.Cookiebot;
        if (!cb || !cb.hasResponse || !cb.consent || cb.consent.preferences) return;
        var cookies = C.get();
        Object.keys(cookies).forEach(function (name) {
          if (/^newsletter-/.test(name) && cookies[name] === 'opened') C.remove(name, { path: '/' });
        });
      } catch (e) {}
    }

    function set() {
      var a = Array.prototype.slice.call(arguments);
      var attr = a[2];
      if (typeof a[0] === 'string' && /^newsletter-/.test(a[0]) && a[1] === 'opened' && !erlaubt()) return undefined;
      if (a.length > 2 && attr && typeof attr === 'object' && typeof attr.expires === 'string' && NUR_ZAHL.test(attr.expires.trim())) {
        /* Kopie mit gleicher Ableitungskette, damit die Auswertung der Bibliothek (for ... in) unveraendert bleibt */
        var kopie = Object.create(attr);
        Object.defineProperty(kopie, 'expires', { value: Number(attr.expires), enumerable: true, writable: true, configurable: true });
        a[2] = kopie;
      }
      return original.apply(this, a);
    }
    set.lbPopupCookie = true;
    set.lbPopupCookieConsent = true;
    set.lbOriginal = original;

    try { C.set = set; } catch (e) { return false; }
    if (C.set !== set) return false;
    ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach(function (name) {
      window.addEventListener(name, widerruf);
    });
    widerruf();
    return true;
  }

  if (umhuellen()) return;
  /* js-cookie noch nicht da (sollte nach theme.js nicht vorkommen): einmal spaeter erneut versuchen */
  function spaeter() { umhuellen(); }
  document.addEventListener('DOMContentLoaded', spaeter, { once: true });
  window.addEventListener('load', spaeter, { once: true });
})();
